import { combineReducers } from 'redux';

import roundPlayReducer from './reducers/roundPlayReducer';
import screenReducer from './reducers/screenReducer';
import sessionReducer from './reducers/sessionReducer';
import characterScreenReducer from './reducers/characterScreenReducer';
import inference from './reducers/inferenceReducer';
import evidence from './reducers/evidenceReducer';
import helpPanel from './reducers/helpPanelReducer';
import VO from './reducers/VOReducer';
import mastery from './reducers/masteryReducer';
import savedData from './reducers/savedDataReducer';

// keeping the reducer collection as a separate exported object enables us
// to do some light test automation on every reducer.
// see ./reducers/__tests__/reducerRejections.test.js
// for more details.
export const reducerCollection = {
  screen: screenReducer,
  roundPlay: roundPlayReducer,
  session: sessionReducer,
  characterScreen: characterScreenReducer,
  inference,
  evidence,
  helpPanel,
  VO,
  mastery,
  savedData,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
